import { ServerApi } from 'modules/api/server-api';

import { decodeResume } from '../../../models/Resume';

export const fetchResume = (api: ServerApi) => async (resumeHash: string) => {
  const response = await api.get(`/resume/${resumeHash}`);
  return decodeResume(response.data.resume);
};
